export function getFrequencyDescription(frequencyPoint, frequencyType) {
  const frequencyMap = {
    D: '天',
    M: '月',
    W: '周',
    year: '年',
  };

  const unit = frequencyMap[frequencyType];
  return unit ? `每${frequencyPoint}${unit}/次` : '';
}
